import { Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'

export default defaultHelpText = ({ text }) ->
  <Tooltip title={text}>
    <QuestionCircleOutlined style={{ marginLeft: 5, color: '#1a936f' }} />
  </Tooltip>
